import { createRef, useRef } from "react";


export const useCreateCategoryRefs = (navItems) => {
    const categoryRefs = useRef([]);
    if (navItems && categoryRefs.current.length !== navItems.length) {
        categoryRefs.current = Array.from({ length: navItems.length }, () => createRef());
    }
    return categoryRefs;
}